export default "__VITE_ASSET__BvjxpQtV__"